export default class LoadElement {
  constructor(id, name, force, lengthL1, parentID) {
    this.id = id;
    this.name = name;
    this.force = force;
    this.lengthL1 = lengthL1;
    this.parentID = parentID;
  }
}
